const LOG_PREFIX = "[OCM][PageSense] "
let pageSense = async (utils) => {
  return new Promise((resolve, reject) => {
    let pageType = 'ROS';
    let subPaths = window.location.pathname.replace("/", "").split("/") || [];
    let customPaths = ["contact", "terms", "tautotita"];
    // Keep only String values in subPaths (removes null and empty)
    subPaths = subPaths.filter(String);
    // The actual page sense goes here
    if (subPaths.length === 0) {
      pageType = "Home";
      //       utils.config.services.lazyload.active = false;
      //       utils.config.services.header_bidding.functionality = "adserver";
    } else if (subPaths.length === 1) {
      if (subPaths[0] === "protoselida") {
        pageType = "Custom-1";
      } else if (customPaths.indexOf(subPaths[0]) >= 0) {
        pageType = "Custom-2";
      } else {
        pageType = "Category";
      }
    } else if (subPaths[0] == "tag") {
      pageType = "Category";
    } else if (subPaths.length >= 3) {
      if (subPaths.indexOf('page') >= 0){
        pageType = "Category";
      } else if(/(\d+)/.test(subPaths[1])){       
        pageType = "Article";
      }
    }

    window.googletag = window.googletag || {cmd: []}

    utils.contentLoaded().then(() => {

      // GAM targeting
      window.googletag.cmd.push(() => {
        googletag.pubads().setTargeting('page', [pageType])
        //         if (pageType === 'Category') {
        //           sub_paths.shift()
        //           googletag.pubads().setTargeting('category', sub_paths)
        //         }

        googletag.pubads().addEventListener('slotRenderEnded', (event) => {
          if (!event.isEmpty) {
            let ad_div = document.getElementById(event.slot.getSlotElementId())
            if (ad_div && event.size.length) {
              let width = event.size[0]
              let height = event.size[1]

              let iframe = ad_div.querySelector('iframe')
              if (iframe) {
                iframe.style = `width:${width}px !important; height:${height}px !important`
              }

            }
          }
        })
      })

      // Slot definitions
      defineSlots(utils, pageType)

      // Ad div detection and display
      let ad_placements = document.querySelectorAll('div[data-ocm-ad]')
      ad_placements.forEach((ap) => {
        window.googletag.cmd.push(() => { googletag.display(ap.id) })
      })
    })
    resolve(pageType)
  });
};

let defineSlots = (utils, pageType) => {

  window.googletag.cmd.push(() => {

    var skin = googletag.sizeMapping()
    .addSize([0, 0], [])
    .addSize([1350, 0], [1, 1])
    .build()

    var prestitialMB = googletag.sizeMapping()
    .addSize([0, 0], [1, 1])
    .addSize([1350, 0], [])
    .build()

    var billboard = googletag.sizeMapping()
    .addSize([0, 0], [[300,600],[300,250]])
    .addSize([340,0], [[300,600],[300,250],[336,280]])
    .addSize([768, 0], [[728,90]])
    .addSize([1024, 0],[[970,250],[970,90],[728,90]])
    .build();

    var sidebar = googletag.sizeMapping()
    .addSize([0, 0], [[300,250],[300,600]])
    .addSize([340,0], [[300,250],[300,600],[336,280]])
    .addSize([768, 0], [[300,250],[300,600]])
    .addSize([1024, 0],[[300,250],[300,600]])
    .build();

    var infeed = googletag.sizeMapping()
    .addSize([0, 0], [[300,250],[300,600]])
    .addSize([340,0], [[300,250],[300,600],[336,280]])
    .addSize([768, 0], [])
    .addSize([1024, 0],[])
    .build();

    var artend = googletag.sizeMapping()
    .addSize([0, 0], [[300,250],[300,600]])
    .addSize([340,0], [[300,250],[300,600],[336,280]])
    .addSize([768, 0], [[728,90]])
    .addSize([1024, 0],[[728,90]])
    .build();

    var mobile_sticky = googletag.sizeMapping()
    .addSize([0, 0], [[320,100],[320,50],[300,50],[300,100],[300,250]])
    .addSize([340,0], [[320,100],[320,50],[300,50],[300,100],[300,250]])
    .addSize([768, 0], [])
    .addSize([1024, 0],[])
    .build();

    var mappingTextlinks = googletag.sizeMapping()
    .addSize([930, 0], [560, 60])
    .addSize([300, 0], [[320, 50], [300, 50]])
    .addSize([0, 0], []).build();

    if (pageType==="Home") {
      googletag.defineSlot('/1026856/flash.gr/billboard1',[[970,250],[970,90],[728,90],[336,280],[300,250],[300,600]],'billboard1').defineSizeMapping(billboard).addService(googletag.pubads());
      googletag.defineSlot('/1026856/flash.gr/billboard2',[[970,250],[970,90],[728,90],[336,280],[300,250],[300,600]],'billboard2').defineSizeMapping(billboard).addService(googletag.pubads());
      googletag.defineSlot('/1026856/flash.gr/billboard3',[[970,250],[970,90],[728,90],[336,280],[300,250],[300,600]],'billboard3').defineSizeMapping(billboard).addService(googletag.pubads());
      googletag.defineSlot('/1026856/flash.gr/billboard_top',[[970,250],[970,90],[728,90],[336,280],[300,250],[300,600]],'billboard_top').defineSizeMapping(billboard).addService(googletag.pubads());
      googletag.defineSlot('/1026856/flash.gr/sidebar1',[[300,600],[300,250],[336,280]],'sidebar1').defineSizeMapping(sidebar).addService(googletag.pubads());
      googletag.defineSlot('/1026856/flash.gr/sidebar2',[[300,600],[300,250],[336,280]],'sidebar2').defineSizeMapping(sidebar).addService(googletag.pubads());
      googletag.defineSlot('/1026856/flash.gr/sidebar3',[[300,600],[300,250],[336,280]],'sidebar3').defineSizeMapping(sidebar).addService(googletag.pubads());
      googletag.defineSlot('/1026856/flash.gr/sidebar4',[[300, 250],[336,280]],'sidebar4').defineSizeMapping(sidebar).addService(googletag.pubads());
      googletag.defineSlot('/1026856/flash.gr/house1',[[300, 250]],'house1').addService(googletag.pubads());
      googletag.defineSlot('/1026856/flash.gr/house2',[[300, 250]],'house2').addService(googletag.pubads());
      if (!utils.is_mobile) {
        googletag.defineSlot('/1026856/flash.gr/home_skin', [1, 1], 'home_skin').defineSizeMapping(skin).addService(googletag.pubads());
        googletag.defineSlot('/1026856/flash.gr/prestitial', [1, 1], 'prestitial').defineSizeMapping(skin).addService(googletag.pubads());
      }
      if (utils.is_mobile) {
        googletag.defineSlot('/1026856/flash.gr/home_mobile1',[[300,600],[300,250],[336,280]],'home_mobile1').defineSizeMapping(sidebar).addService(googletag.pubads());
        googletag.defineSlot('/1026856/flash.gr/prestitial_mobile', [1, 1], 'prestitial_mobile').defineSizeMapping(prestitialMB).addService(googletag.pubads());
      }
    }

    if (pageType==="Category") {
      if (!utils.is_mobile) {
        googletag.defineSlot('/1026856/flash.gr/ros_skin', [1, 1], 'ros_skin').defineSizeMapping(skin).addService(googletag.pubads());
        googletag.defineSlot('/1026856/flash.gr/prestitial', [1, 1], 'prestitial').defineSizeMapping(skin).addService(googletag.pubads());
        googletag.defineSlot('/1026856/flash.gr/billboard1',[[970,250],[970,90],[728,90],[336,280],[300,250],[300,600]],'billboard1').defineSizeMapping(billboard).addService(googletag.pubads());
        googletag.defineSlot('/1026856/flash.gr/sidebar1',[[300,600],[300,250],[336,280]],'sidebar1').defineSizeMapping(sidebar).addService(googletag.pubads());
        googletag.defineSlot('/1026856/flash.gr/sidebar2',[[300,600],[300,250],[336,280]],'sidebar2').defineSizeMapping(sidebar).addService(googletag.pubads());
      }
      if (utils.is_mobile) {
        googletag.defineSlot('/1026856/flash.gr/prestitial_mobile', [1, 1], 'prestitial_mobile').defineSizeMapping(prestitialMB).addService(googletag.pubads());
        googletag.defineSlot('/1026856/flash.gr/infeed1',[[300,600],[300,250],[336,280]],'infeed1').defineSizeMapping(infeed).addService(googletag.pubads());
        googletag.defineSlot('/1026856/flash.gr/infeed2',[[300,600],[300,250],[336,280]],'infeed2').defineSizeMapping(infeed).addService(googletag.pubads());
        googletag.defineSlot('/1026856/flash.gr/infeed3',[[300,600],[300,250],[336,280]],'infeed3').defineSizeMapping(infeed).addService(googletag.pubads());
      }
    }

    if (pageType==="Article") {
      if (!utils.is_mobile) {
        googletag.defineSlot('/1026856/flash.gr/ros_skin', [1, 1], 'ros_skin').defineSizeMapping(skin).addService(googletag.pubads());
        googletag.defineSlot('/1026856/flash.gr/prestitial', [1, 1], 'prestitial').defineSizeMapping(skin).addService(googletag.pubads());
        googletag.defineSlot('/1026856/flash.gr/billboard1',[[970,250],[970,90],[728,90],[336,280],[300,250],[300,600]],'billboard1').defineSizeMapping(billboard).addService(googletag.pubads());
        googletag.defineSlot('/1026856/flash.gr/sidebar1',[[300,600],[300,250],[336,280]],'sidebar1').defineSizeMapping(sidebar).addService(googletag.pubads());
        googletag.defineSlot('/1026856/flash.gr/sidebar2',[[300,600],[300,250],[336,280]],'sidebar2').defineSizeMapping(sidebar).addService(googletag.pubads());
        googletag.defineSlot('/1026856/flash.gr/sidebar3',[[300,600],[300,250],[336,280]],'sidebar3').defineSizeMapping(sidebar).addService(googletag.pubads());
        googletag.defineSlot('/1026856/flash.gr/sidebar4',[[300,600],[300,250],[336,280]],'sidebar4').defineSizeMapping(sidebar).addService(googletag.pubads());
        googletag.defineSlot('/1026856/flash.gr/article_end',[[728,90],[300,600],[300,250],[336,280]],'article_end').defineSizeMapping(artend).addService(googletag.pubads());

        googletag.defineSlot('/1026856/flash.gr/article_textlinks', [[320, 50], [300, 50], [560, 60]], 'article_textlinks').defineSizeMapping(mappingTextlinks).addService(googletag.pubads());
        googletag.defineSlot('/1026856/flash.gr/article_textlinks_2', [[320, 50], [300, 50], [560, 60]], 'article_textlinks_2').defineSizeMapping(mappingTextlinks).addService(googletag.pubads());
      }
      if (utils.is_mobile) {
        googletag.defineSlot('/1026856/flash.gr/prestitial_mobile', [1, 1], 'prestitial_mobile').defineSizeMapping(prestitialMB).addService(googletag.pubads());
      }
    }
  })
}
module.exports = pageSense;